// extracted by mini-css-extract-plugin
export default {"watchListCardContainerClass":"watchListCardContainerClass","watchlistCard":"watchlistCard","ant-card-body":"ant-card-body","watchlistStatus":"watchlistStatus","watchlistRating":"watchlistRating","watchlistDays":"watchlistDays"};
    if(module.hot) {
      // 1793340219987
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  